import { Box, IconButton, Typography } from "@sidelinesports/fan-design-system";
import { CancelIcon, DblChevronRightIcon } from "@sidelinesports/icons";
import type { ApiGameMessage } from "../../../../../api/index.ts";
import { UploadedImage } from "../../../../../components/index.tsx";
import { useExternalLinkProps } from "../../../../../hooks/index.ts";
import styles from "./Toast.module.css";

export const FeaturedMessageToast = ({
  message,
  onDismiss,
}: {
  message: ApiGameMessage;
  onDismiss: () => void;
}) => {
  return (
    <Box
      as="a"
      bg="primary"
      className={styles.toastBox}
      p={16}
      data-track-link-name={`FeaturedMessageToast:${message.id}`}
      {...useExternalLinkProps(message.link || null, {
        utm: {
          content: "featured-message-lower-third",
        },
      })}
    >
      {message.image && (
        <Box className={styles.imageBox}>
          <UploadedImage
            alt=""
            image={message.image}
            aspectRatio="1/1"
            tracking={{ location: "Featured Message (Lower Third)" }}
          />
        </Box>
      )}
      <Typography size="lg" className={styles.messageText}>
        {message.text}
        {message.link && <DblChevronRightIcon className={styles.chevronIcon} />}
      </Typography>
      <IconButton
        variant="outline-light"
        aria-label="Close"
        size="lg"
        icon={<CancelIcon />}
        onClick={(e) => {
          onDismiss();
          e.stopPropagation();
          e.preventDefault();
        }}
        data-track-link-name="Close"
      />
    </Box>
  );
};
